





























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import ParametersEditModal from '@/components/parameters/edit-modal.vue';
import ParameterModel from '@/models/parameter-model';
import { toNumber } from '@/helpers/toNumber';

@Component({
  components: {
    PermissionAuth,
    ParametersEditModal,
  },
})
export default class ParametersFormIntegerType extends BaseComponent {
  @Prop()
  public editItem: any;
  @Prop()
  public modalOpen: boolean;

  public item: ParameterModel = new ParameterModel();

  public rules: any = {
    integer: [(val) => !!toNumber(val) || 'Digite um valor maior que 0'],
  };

  @Watch('editItem')
  public onEditItemChanges(val: any) {
    this.item = new ParameterModel();

    if (!val) {
      return;
    }

    this.item = new ParameterModel(this.editItem);
  }

  public beforeMount(): void {
    this.onEditItemChanges(this.editItem);
  }

  public onClose(): void {
    this.$emit('close');
  }
}
